import { useGLTF, Text } from "@react-three/drei";
import {
  RigidBody,
  CylinderCollider,
  CuboidCollider,
} from "@react-three/rapier";
import { useFrame } from "@react-three/fiber";
import { useRef } from "react";
import PointerShadow from "../pointers/PointerShadow.jsx";
import { MODELS } from "../loader/models.js";

const PizzaFinish = ({
  position = [0, 0, 0],
  pizzaPosition = [0, 0, 0],
  boardPosition = [0, 0, 0],
  pizzaScale = 1,
  boardScale = 1,
  showPizza = true,
  showBoard = true,
  pizzaRotationSpeed = 0.5, // скорость вращения пиццы
}) => {
  const { nodes } = useGLTF(MODELS.PIZZA_FINISH);
  const pizzaRef = useRef();

  // Анимация вращения пиццы
  useFrame((state, delta) => {
    if (pizzaRef.current) {
      pizzaRef.current.rotation.y += delta * pizzaRotationSpeed;
    }
  });

  return (
    <group position={position}>
      <Text
        fontSize={0.9}
        color={"white"}
        rotation-x={-Math.PI / 2}
        position={[-15, -0.99, -8]}
      >
        #PizzaMaker
      </Text>
      {/* Отображаем Pizza отдельно */}
      <PointerShadow width={20} height={20} opacity={0.5} softness={0.8} />

      {showPizza && nodes.Pizza && (
        <primitive
          ref={pizzaRef}
          scale={pizzaScale}
          object={nodes.Pizza}
          position={pizzaPosition}
        />
      )}

      {/* Отображаем Board отдельно */}
      {showBoard && nodes.Board && (
        <group>
          <RigidBody type="fixed" ccd={false}>
            <CylinderCollider args={[1, 3]} />
          </RigidBody>
          <primitive
            scale={boardScale}
            object={nodes.Board}
            position={boardPosition}
          />
          <group position={[0, 0, 4]}>
            <PointerShadow width={5} height={5} opacity={0.2} softness={0.8} />
            <RigidBody type="fixed" ccd={false}>
              <CuboidCollider args={[0.5, 1, 0.5]} />
            </RigidBody>
          </group>
        </group>
      )}
    </group>
  );
};

export default PizzaFinish;
